module.exports = __webpack_public_path__ + "static/img/about_two.7bcfac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/about_two.png
// module id = D7wF
// module chunks = 1